import {createMuiTheme} from '@material-ui/core';

export const rieltor = {
  fontFamily: 'Inter, sans-serif',
  lunFontFamily: "'Lun', Arial, Helvetica, sans-serif",
  mainGradient: 'linear-gradient(180deg, #81F 0%, #DA48C5 100%)',
  mainGradientHorizontalLeft: 'linear-gradient(270deg, #81F 0%, #DA48C5 100%)',
  mainGradientHorizontalRight: 'linear-gradient(90deg, #81F 0%, #DA48C5 100%)',
  whiteTransparent: 'rgba(255, 255, 255, 0.6)',
  mainBg: '#8811ff',
  gray: '#4C5B6B',
  gray4: '#979FA9',
  grayFill: '#F3F4F6',
  grayLines: '#E9ECF1',
  grayLight: '#FAFAFC',
  grayBody: '#fafafa',
  purple: '#81F',
  purplePushed: '#701BCE',
  yellow: '#FFCB2B',
  lightViolet: '#F0F1FA',
  green: '#00C070',
  greenLight: '#E8FDF7',
  orange: '#D57D73',
  orangeLight: '#F9EEED',
  orangeDark: '#FF6605',
  pink: '#DA48C5',
  pinkLight: '#FAF0F9',

  labelMagenta: '#CA53C0',
  labelMagentaLight: '#FFF2FE',
  labelYellow: '#E5B53D',
  labelYellowLight: '#FFF5D4',
  labelBlue: '#4181C5',
  labelBlueLight: '#E3EDFF',
  labelOrange: '#F37549',
  labelOrangeLight: '#FFECE5',
  labelRed: '#EB3D00',
  labelRedLight: 'rgba(235, 61, 0, 0.10)',

  chartBlue: '#3366cc',
  chartRed: '#dc3912',
  chartOrange: '#ff9900',
  chartGreen: '#109618',
  chartBirdColor: '#000050',
  chartLunTopColor: '#ff9900',
  chartFreeColor: '#CA53C0',
  chartPremium: '#81F',
};

export const iosVersion = parseInt(
  (navigator.appVersion).match(/Version\/(\d+).(\d+)_?(\d+)?/)?.[1] || '0',
  10,
);


const theme = createMuiTheme({
  props: {
    MuiDialog: {
      TransitionProps: {
        onEnter: () => document.body.classList.add("dialog-open"),
        onExited: () => document.body.classList.remove("dialog-open"),
      },
    },
  },
  palette: {
    primary: {
      main: rieltor.purple,
    },
  },
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': iosVersion >=26 ? {
        '& .MuiDialog-root': {

        },
        '& .MuiBackdrop-root': {
          height: '110vh',
          position: 'absolute !important' as any,
        }
      }: {}
    },
    MuiButton: {
      label: {
        textTransform: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
  },
  typography: {
    h6: {
      fontFamily: rieltor.lunFontFamily
    }
  }
});

export {theme};
